import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-2770c75c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex fx-c"
};
const _hoisted_2 = {
  class: "ads-wrapper"
};
const _hoisted_3 = {
  class: "innovation flex fx-c"
};
const _hoisted_4 = {
  class: ""
};
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex fy-c fx-c"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "default w100 h100",
  src: _imports_0
})], -1));
import { useStore } from 'vuex';
import { computed } from '@vue/runtime-core';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import AdContainer from '@/components/AdContainer.vue';
import VideoSwiper from './components/VideosSwiper.vue';
import home from '@/assets/data/home';
export default {
  __name: 'HomeView',
  setup(__props) {
    const store = useStore();
    const modules = [Autoplay, Pagination, Navigation];
    const {
      banner,
      ads,
      slogan,
      videos,
      innovation
    } = home;
    let isMobile = computed(() => store.state.bk.global.isMobile);
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['main', _unref(isMobile) ? 'h5' : 'pc'])
      }, [_createVNode(_unref(Swiper), {
        class: "w100",
        modules: modules,
        navigation: false,
        pagination: true,
        autoplay: {
          delay: 3000,
          speed: 1000,
          loop: true,
          reverseDirection: true,
          disableOnOnsteraction: false
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(banner), li => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: li.id
          }, {
            default: _withCtx(() => [_createVNode(AdContainer, {
              link: li.link,
              imgUrl: li.img_url[_unref(isMobile) ? 'h5' : 'pc']
            }, null, 8, ["link", "imgUrl"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ads), (li, i) => {
        return _openBlock(), _createBlock(AdContainer, {
          class: _normalizeClass({
            first: i === 0
          }),
          key: li.id,
          link: li.link,
          imgUrl: li.img_url
        }, null, 8, ["class", "link", "imgUrl"]);
      }), 128))])]), _createVNode(VideoSwiper, {
        class: "videos",
        videos: _unref(videos)
      }, null, 8, ["videos"]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(Swiper), {
        style: {
          "width": "60rem"
        },
        modules: modules,
        navigation: false,
        pagination: true,
        autoplay: {
          delay: 3000,
          speed: 1000,
          loop: true,
          reverseDirection: true,
          disableOnOnsteraction: false
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innovation), li => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: li.id
          }, {
            default: _withCtx(() => [_createVNode(AdContainer, {
              link: li.link,
              imgUrl: li.img_url[_unref(isMobile) ? 'h5' : 'pc']
            }, null, 8, ["link", "imgUrl"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
        href: _unref(slogan).link
      }, [_createVNode(_component_el_image, {
        class: "w100",
        src: _unref(slogan).img_url[_unref(isMobile) ? 'h5' : 'pc'],
        fit: "contain",
        loading: "lazy"
      }, {
        placeholder: _withCtx(() => [_hoisted_6]),
        _: 1
      }, 8, ["src"])], 8, _hoisted_5)])], 2);
    };
  }
};